module.exports = __webpack_public_path__ + "static/gradilla-fcd0ea7a54789cae95ef69dc04f93050.jpg";